import trim from "lodash/trim"
import { object, string } from "yup"

export const zipSchema = string()
  .matches(/^[0-9-]*$/, "number")
  .min(3, "min-string-3")

export const zipRequiredSchema = zipSchema.required("required")

export const cityNameSchema = string()
  .transform((value) => trim(value, ",; "))
  .required("required")
  .matches(/^[^,;]+$/gi, "multiple-cities-input")

export const locationSchema = object({
  city: object({ city: cityNameSchema }).nullable().required("required"),
  zip: object({ zip_code: zipRequiredSchema }).nullable().required("required"),
  street: string().nullable(),
  street_number: string().nullable()
})
